module.exports = __webpack_public_path__ + "static/img/pic10.f7402ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/pic10.png
// module id = 1666
// module chunks = 2